import confirm from "./modules/zh/confirm";
import commonExt from "./modules/zh/commonExt";
import orderExt from "./modules/zh/orderExt";
import rider from "./modules/zh/rider";
import store from "./modules/zh/store";
import finance from "./modules/zh/finance";
import data from "./modules/zh/data";
import set from "./modules/zh/set";
import plugin from "./modules/zh/plugin";
import jurisdiction from "./modules/zh/jurisdiction";
import dashboardExt from "./modules/zh/dashboardExt";
import activationExt from "./modules/zh/activationExt";
import app from "./modules/zh/app";

export default {
  lang: {
    label: "语言",
    zhCN: "简体中文",
    frFR: "Français",
  },
  header: {
    welcome: "欢迎您，",
    platformId: "平台ID：",
    logout: "退出",
  },
  menu: {
    overview: "概 况",
    order: "订 单",
    orderList: "订单列表",
    revokeOrder: "撤销订单",
    rider: "骑 手",
    riderList: "骑手列表",
    riderAuth: "认证审核",
    riderLevel: "骑手等级",
    riderSet: "骑手设置",
    store: "商 户",
    storeList: "商户列表",
    storeValue: "商户储值",
    priceSet: "计价设置",
    finance: "财 务",
    assetOverview: "资产总览",
    riderAsset: "骑手资产",
    shopAsset: "商户资产",
    withdrawalList: "提现列表",
    withdrawalSet: "提现设置",
    data: "数 据",
    orderAnalysis: "订单分析",
    riderAnalysis: "骑手分析",
    application: "应 用",
    settings: "设 置",
    platformSet: "平台设置",
    agreement: "协议规则",
    versionUpdate: "版本更新",
    noticeManage: "公告管理",
    messageManage: "通知管理",
    permission: "权限设置",
    appletList: "小程序列表",
    superAuth: "超级权限",
    empower: "授权详情",
  },
  common: {
    confirm: "确定",
    cancel: "取消",
    tip: "温馨提示",
    filter: "筛选",
    pleaseSelect: "请选择",
    startDate: "开始日期",
    endDate: "结束日期",
    to: "至",
    loading: "正在加载中...",
    noRowSelected: "未选中任何行",
    comingSoon: "敬请期待",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    add: "添加",
    search: "搜索",
    operation: "操作",
    detail: "详情",
    start: "起",
    end: "止",
    yuan: "元",
    order: "单",
    person: "人",
    store: "家",
    ...commonExt,
  },
  confirm,
  orderState: {
    pending: "待接单",
    arrive: "待到店",
    pickup: "待取货",
    delivering: "配送中",
    completed: "已完成",
    cancelled: "已取消",
  },
  dashboard: {
    todayOrders: "今日订单数（单）",
    yesterdayOrders: "昨日订单数：",
    totalOrders: "总订单数：",
    todayIncome: "今日营业额（元）",
    yesterdayIncome: "昨日营业额：",
    totalIncome: "总营业额：",
    waitRider: "待审核骑手（人）",
    onlineRider: "在岗骑手数",
    onlineRiderTip: "指目前已在线的骑手数量",
    certifiedRider: "已认证骑手数：",
    waitStore: "待审核商家（家）",
    partnerStore: "合作商家：",
    pendingAccept: "待接单（单）",
    delivering: "配送中（单）",
    cancelRights: "取消/维权（单）",
    orderTrend: "订单走势",
    incomeTrend: "收入走势",
    ...dashboardExt,
  },
  order: {
    listTitle: "订单列表",
    orderStatus: "订单状态",
    orderTime: "下单时间",
    orderNo: "订单编号",
    orderNoPh: "请输入订单编号",
    customerTel: "客户电话",
    customerTelPh: "请输入客户电话",
    storeName: "商户名称",
    storeNamePh: "请输入商户名称",
    riderName: "骑手姓名",
    riderNamePh: "请输入骑手姓名",
    pushTime: "推单时间",
    orderType: "订单类型",
    takeaway: "外卖订单",
    orderStore: "下单商户",
    orderAmount: "订单金额(元)",
    startAddress: "起始地址",
    all: "全部",
    acceptRider: "接单骑手",
    commission: "所得佣金(元)",
    deleteConfirm: "你确定要同意删除订单吗",
    ...orderExt,
  },
  rider,
  store,
  finance,
  data,
  set,
  plugin,
  jurisdiction,
  app,
  request: {
    networkError: "后端接口连接异常",
    timeout: "后端接口请求超时",
    statusError: "后端接口{code}异常",
    unknownError: "后端接口未知异常",
    apiError: "后端接口{code}异常",
  },
  activation: {
    enterCode: "请输入激活码",
    ...activationExt,
  },
  map: {
    locationFail: "当前位置无法检测！",
  },
  train: {
    fillTimeRange: "请填写完整起止时间段！",
  },
  login: {
    title: "配送管理后台",
    subtitle: "请使用应用账号登录",
    userName: "登录账号",
    userNamePh: "请输入登录账号",
    password: "登录密码",
    passwordPh: "请输入密码",
    submit: "登录",
    userNameRequired: "请输入登录账号",
    passwordRequired: "请输入密码",
    success: "登录成功",
    sessionFailed:
      "登录成功但未建立配送会话，请使用平台用户账号（ybps_users）登录",
  },
};
